import { bamboo, drift, leaf } from '../motifs';
import { registerPlate } from '../registry';

const STALK = ['#a8d070', '#5e9a40', '#356a2a'] as const;
const LEAF = ['#9ad06a', '#4e8a38', '#2c5a24'] as const;

/** 05 นักเดินทาง: the wanderer's plate, dark green lacquer between stands of bamboo. */
registerPlate({
  id: 'wanderer',
  name: 'นักเดินทาง',
  ground: ['#3c5e3c', '#22382a', '#14241a'],
  trim: '#a08a4a',
  text: { fill: ['#f4ecc0', '#d0c080'], line: '#0c160e' },
  inset: [13, 13],
  front(p, f) {
    bamboo(p, f.x, f.y - 14, f.b + 8, 3, STALK, 8);
    bamboo(p, f.x + 6, f.y - 8, f.b + 4, 2.5, STALK, 7);
    bamboo(p, f.r - 3, f.y - 16, f.b + 8, 3, STALK, 8);
    bamboo(p, f.r - 9, f.y - 7, f.b + 3, 2.5, STALK, 7);
    for (const [x, y, a, l] of [
      [f.x + 3, f.y - 6, -2.6, 7],
      [f.x + 3, f.y - 3, -2.2, 6],
      [f.x + 8, f.y - 3, -0.5, 6],
      [f.x + 3, f.b - 2, 2.6, 6],
      [f.r - 2, f.y - 7, -0.5, 7],
      [f.r - 2, f.y - 4, -0.9, 6],
      [f.r - 7, f.y - 2, -2.7, 6],
      [f.r - 2, f.b - 1, 0.5, 6],
    ] as const)
      leaf(p, x, y, a, l * 1.35, 3.2, LEAF);
  },
  motion: {
    sprites: { leaf: { w: 5, h: 3, draw: (p) => leaf(p, 0, 1, 0.3, 5, 2, LEAF) } },
    play(a, t, f) {
      drift(a, 'leaf', t, 2, f.r - 12, 10, f.y - 6, f.b + 8, { speed: 0.22, sway: 3 });
    },
  },
});
